import { MarketType } from '../bids-and-offers/lots.model';

export class User {
  constructor(
    public email: string,
    public id: string,
    private _accessToken: string,
    private _accessTokenExpirationDate: Date,
    private _refreshToken: string,
    private _refreshTokenExpirationDate: Date
  ) {}

  get accessToken() {
    if (
      !this._accessTokenExpirationDate ||
      new Date() > this._accessTokenExpirationDate
    ) {
      return null;
    }
    return this._accessToken;
  }

  get refreshToken() {
    if (
      !this._refreshTokenExpirationDate ||
      new Date() > this._refreshTokenExpirationDate
    ) {
      return null;
    }
    return this._refreshToken;
  }
}

export interface UserDetails {
  _id: string;
  createdAt: string;
  updatedAt: string;
  default_commodity: string;
  email: string;
  first_name: string;
  last_name: string;
  role: UserRoles;
  market_options: MarketType[];
  default_market_type: MarketType;
  favorable_commodities: string[];
  default_origin: string;
  accepted_agreements?: boolean | null;
  notificationPreferences?: {
    topics: string[];
    bids: boolean;
    offers: boolean;
    trades: boolean;
    contracts: boolean;
    negotiations: boolean;
    commodities: string[];
  };
  receive_email_notifications: boolean;
  email_preferences: {
    contracts: boolean;
    bids: boolean;
    commodities: string[];
    offers: boolean;
    negotiations: boolean;
    trades: boolean;
  };
}

export enum UserRoles {
  Broker = 'broker',
  Trader = 'trader',
  Farmer = 'farmer',
  Viewer = 'viewer',
  Feeder = 'feeder',
}

export interface EmailPreferencesInput {
  bids: boolean;
  offers: boolean;
  commodities: string[] | null;
  negotiations: boolean;
  trades: boolean;
  contracts: boolean;
}

export interface UpdateNotificationPreferencesInput {
  topics: string[];
  bids: boolean;
  offers: boolean;
  commodities: string[] | null;
  negotiations: boolean;
  trades: boolean;
  contracts: boolean;
}
